import { createContext, useState, useContext } from "react";

const UIContext = createContext();

export function UIProvider({ children }) {
  const [tabValue, setTabValue] = useState(0);

  return (
    <UIContext.Provider value={{ tabValue, setTabValue }}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  return useContext(UIContext);
}
